export default __webpack_public_path__ + "static/media/copy.0364ffe0.svg";